import * as Interfaces from './interfaces'
import store from './store'

export default store

export { Interfaces }
